import { ClassNames } from "@emotion/react";
import { DateTime } from "luxon";
import Link from "next/link";
import { CSSProperties, forwardRef, useEffect, useImperativeHandle, useRef, useState, JSX} from "react";
import { JWHostedPlayerProps, JWPlayerProps, SearchJson, Video, VideoAncillaryLink, VideoSearchResult } from "../lib/definitions";
import { consoleError, consoleLog, logEvent, registerBrowser, trackFathomEvent } from "../lib/logger";
import { useRawUmberContext } from "../lib/rawumberprovider";
import useAuth, { subscriptionDescription } from "../lib/useAuth";
import { DateAndTime } from "./Localization";
import styles from "./Video.module.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock} from '@fortawesome/pro-solid-svg-icons'
import { useRouter } from "next/router";
import ReactDOMServer from 'react-dom/server';
import { TrimDescription } from "../lib/utils";
import CornerBanner from "./CornerBanner";
import Cookies from "universal-cookie";
import { AspectBox } from "./AspectBox";
import * as Sentry from "@sentry/nextjs";
import next from "next";
import { Button, Stack } from "@mantine/core";
import { ReplicationRuleFilter } from "@aws-sdk/client-s3";
import { useAuth as useClerkAuth } from '@clerk/nextjs'
import { getClerkHeader } from "../lib/common";

type VideoPlayInformation =
    {
        seconds: number,
        previousPosition: number,
        seconds30: boolean,
        seconds300: boolean,
        percentage1: boolean, //just for testing really
        percentage25: boolean,
        percentage50: boolean,
        percentage75: boolean,
        percentage95: boolean,
        timerId: number,
        videoId: number,
        count: number,
        totalDuration: number,
        running: boolean,
        player: jwplayer.JWPlayer
    }

let videoPlayers = new Map<number, VideoPlayInformation>();
let _interval = 200;

export function VideoList(props: {videos : Video [], hideWarnings?:boolean, dateProcessed: string, usePasswords?: boolean})
{
    
return(<div className={styles.results}>
{props.videos.map(video => {
  return <VideoElement key={video.id} video={video} hideWarnings={props.hideWarnings} dateProcessed={props.dateProcessed} usePassword={props.usePasswords??false}/>
})}
</div>);
}

export function BigVideo(props2:{video:Video | undefined | null, hideWarnings?: boolean, dateProcessed : string})
{
    const [currentDate, setCurrentDate] = useState(DateTime.fromISO(props2.dateProcessed));
    const {timeOffset} = useRawUmberContext();
    const [firstRender, setFirstRender] = useState(true);
    const { userInformation, authToken} = useAuth();
    const { isSignedIn } = useClerkAuth();
    const loggedIn = isSignedIn;
    const nextVideo = useRef<Video|undefined>(undefined);

    const [finished, setFinished] = useState(false);



    //not that this should always be in the past (and may or may not be acccessible) OR in the future but not accessible
    useEffect(() =>
    {

        let realDate = DateTime.now().toUTC().plus(timeOffset??0)
        setCurrentDate(realDate);
        setFirstRender(false);

    }
        ,[true, timeOffset]
    );

    const router = useRouter();
    const { getToken } = useClerkAuth();


    useEffect(()=>
    {

        async function getNextVideo()
        {
            const clerkToken = await getToken();

            let options = { 
                method: 'GET',
                cache: "no-store" as RequestCache,
                 headers: {... authToken?{'auth-token': authToken}:{}, ...getClerkHeader(clerkToken)} as HeadersInit
                };
    

            let v = await (await fetch(process.env.NEXT_PUBLIC_ELTON_ROUTE + "/nextvideo?id=" + props2.video?.id, options)).json();

            if (v)
            {
                if (v.id!=0)
                {
                nextVideo.current = v.id;

                let search : SearchJson =
                {
                    VideoIds: [v.id],
                    Offset:0,
                    Count:1,
                    DateTo: DateTime.now().toUTC().plus({day:14}).toJSDate().toISOString()
                }

                const result: VideoSearchResult = await (await fetch(process.env.NEXT_PUBLIC_ELTON_ROUTE + "/videosearch?json=" + JSON.stringify(search), options)).json();

                if (result.videos.length!=0)
                {
                    nextVideo.current=result.videos[0];

                    //console.log(nextVideo.current);
                }

            }
            }

           
        }

        getNextVideo();
        

    }, []);

    const ref=useRef<JWPlayerHandle>(null);

    if (!props2.video)
    {
        return <></>
    }

    function videoFinished()
    {

        setFinished(true);

    }

    function watchNextVideo()
    {
       if (nextVideo.current)
       {
        var url = `/videos/${nextVideo.current.slug}`;
        router.push(url);
       }
    }

    function rewatchVideo()
    {
        setFinished(false);

        //console.log(ref.current);

        if (ref.current)
        {
        ref.current.rewatch();
        }
    }



    let live = props2.video.isLiveSession;


    let strictlyInTheFuture = (currentDate < DateTime.fromISO(props2.video.dateLive));

   // console.log("live:" + live);
  //  console.log("in the future:" + props2.video.inTheFuture);
 //   console.log((!props2.video.inTheFuture && !live));
    if (props2.video.accessible && (!(props2.video.inTheFuture && !live) || (!strictlyInTheFuture && !live)))
    {
        //console.log("Here!");
        //should always be in the past
        //NOT true - might be not live 
        let placeHolder = <>
        <div className={styles.bigContainer}>
            <img className={styles.bigImage} src={"https://rawumberstudios.com/rus-videos/images/previews/" + props2.video.thumbnail}/>
            <div className={styles.centredOverlay}>
            </div>
            </div>
        </>
        if (typeof window === 'undefined' || firstRender)
        {
           return (<div className={styles.overallContainer}>{placeHolder}</div>);
       }  
        else
        {  
            return <AspectBox width={16} height={9}>
                {finished && <>
                    <div className={styles.bigContainer}>
                        <img className={styles.bigLockedImage} src={"https://rawumberstudios.com/rus-videos/images/previews/" + props2.video.thumbnail}/>

            <div className={styles.centredOverlay}>
                <div className={styles.lockedText}>
                    <Stack>
                        {nextVideo.current && <>
                        <Button size="xl" onClick={watchNextVideo}>
                        {props2.video.isTrailer ? "Play the first video":"Play the next video"}
                    </Button></>}
                    <Button onClick={rewatchVideo}>{props2.video.isTrailer ? "Rewatch the trailer":"Rewatch this video"}</Button>
                    </Stack>
                    
                    </div>
            </div>
            </div>
                </>}
                <div style={{display:(finished?'none':'block')}}>
                <JWPlayer uniqueKey={"full-jw-" + props2.video.id} ref={ref} video={props2.video} large placeHolder={placeHolder} dateProcessed={props2.dateProcessed} videoFinished={videoFinished}/>
                </div>
                </AspectBox>
        }
    }


    //if (props2.video.inTheFuture)
    {
        //get people to sign up, or upgrade

        let message=<></>

        if (strictlyInTheFuture && !live)
        {
            message = <><TimeLeft video={props2.video} currentDate={currentDate}/></>
        }
        else
        {

        
        let requiredLevel = "Standard";

        if (props2.video.subscriberLevel=="gold")
        {
            requiredLevel="Gold";
        }

        if (loggedIn && userInformation)
        {

            let currentLevel = subscriptionDescription(userInformation);
            
            //message=<>This video is only available to {requiredLevel} subscribers. You are a Raw Umber {currentLevel} subscriber. Please <a href="mailto:info@rawumberstudios.com">contact us</a> to upgrade</>
            message=<>This video is only available to Gold subscribers. You are a Raw Umber {currentLevel} subscriber. Please <a href="mailto:info@rawumberstudios.com">contact us</a> to upgrade</>

        }
        else
        {
            let link ="/log-in?redirect_to=/videos/" + props2.video.slug;
            message =<>This video is only available to subscribers. Please <Link href="/raw-umber-subscription">purchase a subscription</Link> or <Link href={link}> log in to your account</Link></>
        }
    }



        return(<div className={styles.bigContainer}>
            <img className={styles.bigLockedImage} src={"https://rawumberstudios.com/rus-videos/images/previews/" + props2.video.thumbnail}/>
            <div className={styles.centredOverlay}>
                <div className={styles.lockedText}>{message}</div>
            </div>
            </div>
        );
    }

    return <></>
}

function handeJWPlayerError(error: jwplayer.ErrorParam)
{
    let e = new Error(error.message);
    consoleError(e, error);
    
}

export function JWHostedPlayer(props: JWHostedPlayerProps)
{
    const player = useRef<jwplayer.JWPlayer|null>(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() =>
    {
  
        Sentry.addBreadcrumb({message:`Adding hosted JWPlayer(${props.jwId})`});

        if (typeof jwplayer!='undefined')
        {
      
        let p = jwplayer('jw-hosted-' + props.jwId);

        if (p && typeof(p.setup)=='function') {
                      
            player.current = jwplayer('jw-hosted-' + props.jwId).setup(
                {
                    autostart: props.autostart,
                    controls: props.controls,
                    mute:props.mute,
                    file:`https://cdn.jwplayer.com/manifests/${props.jwId}.m3u8`,                                        
                    image: `https://cdn.jwplayer.com/v2/media/${props.jwId}/poster.jpg?width=1280`,
                    repeat: props.loop
                });

                player.current.on('error', ()=>handeJWPlayerError);
                player.current.on('setupError', ()=>handeJWPlayerError);

                setLoaded(true);
        }
    }
    return (() => {
        if (player.current)
        {            
            player.current.remove();
        }        
    });

    }, [props.jwId]);


    return <div key={'jw-hosted-' + props.jwId}>
        <SafeJWPlayer id={'jw-hosted-' + props.jwId}/>

{!loaded && <div className={styles.bigContainer}>
            <img className={styles.bigImage} src={`https://cdn.jwplayer.com/v2/media/${props.jwId}/poster.jpg?width=1280`}/>
            <div className={styles.centredOverlay}>
            </div>
            </div>}

    </div>

}

export function SafeJWPlayer(props: {id: string})
{
    return <div className={styles.videoWrapper}><div id={`${props.id}`}></div></div>
}


//now that aspect ratios work correctly, can just embed it normally into a parent div

export function JWHostedPlayer2(props: JWHostedPlayerProps)
{
    const player = useRef<jwplayer.JWPlayer|null>(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() =>
    {
  
        Sentry.addBreadcrumb({message:`Adding hosted JWPlayer(${props.jwId})`});

        if (typeof jwplayer!='undefined')
        {
      
        let p = jwplayer('jw-hosted-' + props.jwId);

        if (p && typeof(p.setup)=='function') {
                      
            player.current = jwplayer('jw-hosted-' + props.jwId).setup(
                {
                    autostart: props.autostart,
                    controls: props.controls,
                    mute:props.mute,
                    file:`https://cdn.jwplayer.com/manifests/${props.jwId}.m3u8`,                                        
                    image: `https://cdn.jwplayer.com/v2/media/${props.jwId}/poster.jpg?width=1280`,
                    repeat: props.loop
                });

                player.current.on('error', ()=>handeJWPlayerError);
                player.current.on('setupError', ()=>handeJWPlayerError);

                setLoaded(true);
        }
    }
    return (() => {
        if (player.current)
        {            
            player.current.remove();
        }        
    });

    }, [props.jwId]);


    return <div key={'jw-hosted-' + props.jwId}>
        <SafeJWPlayer2 id={'jw-hosted-' + props.jwId}/>

{!loaded && <div className={styles.bigContainer}>
            <img className={styles.bigImage} src={`https://cdn.jwplayer.com/v2/media/${props.jwId}/poster.jpg?width=1280`}/>
            <div className={styles.centredOverlay}>
            </div>
            </div>}

    </div>

}

export function SafeJWPlayer2(props: {id: string})
{
    return <div><div id={`${props.id}`}></div></div>
}



export function VideoElement(props2:{video:Video, hideWarnings?: boolean, dateProcessed : string, featured?:boolean, usePassword?: boolean }) {
 
    //note that dateProcessed is always an ACCURATE time string
    const {isSignedIn: loggedIn} = useClerkAuth();
    const [currentDate, setCurrentDate] = useState(DateTime.fromISO(props2.dateProcessed));
    const {timeOffset} = useRawUmberContext();

    const [firstRender, setFirstRender] = useState(true);
    const router = useRouter();
    
    let v: Video = props2.video;
    let m = (DateTime.fromISO(v.dateLive).diff(currentDate).as("milliseconds")/60/1000);
    //let m = -100;

    useEffect(() =>
    {

        let realDate = DateTime.now().toUTC().plus(timeOffset??0)
        setCurrentDate(realDate);
        setFirstRender(false);

    }
        ,[timeOffset]
    );

    let minutes = m;

    //setMinutes(m);

    let image = <></>;
    let url = '/videos/' + v.slug;

    if (props2.usePassword && v.password)
    {
        url += "?password=" + v.password;
    }

    //console.log(v.password);

    let urlText = <Link href={url}>Click here to watch it</Link>
    let containerClass = styles.container;

    if ((minutes??100) > -45) {
        image = <Link href={v.accessible ? `/videos/${v.slug}` : `/booking/${v.slug}`}><img src={'https://rawumberstudios.com/rus-videos/images/thumbnails/' + v.thumbnail} /></Link>;
    }
    else if (!v.accessible) {

        image = <><img className={styles.lockedImage} src={'https://rawumberstudios.com/rus-videos/images/thumbnails/' + v.thumbnail} />
        <div className={styles.videoPadlock}><FontAwesomeIcon icon={faLock} size="2x"/></div>
        </>;
    }
    else if (v.isSeries) {
        image = <><img src={'https://rawumberstudios.com/rus-videos/images/thumbnails/' + v.thumbnail} /></>;
    }
    else {          
         if (typeof window === 'undefined' || firstRender)
         {

            image = <Link href={'/videos/' + v.slug}><img src={'https://rawumberstudios.com/rus-videos/images/thumbnails/' + v.thumbnail} /></Link>;
        }  
         else
         {
   
            image = <JWPlayer video={v} dateProcessed={props2.dateProcessed} uniqueKey={props2.featured?"jw-featured":("jw-" + v.id)}/>
            //containerClass="";
         }
            
    }

    let title = <Link href={url}>{v.title}</Link>;
    let tutorName = v.tutor?.name;

    let videoDate = <DateAndTime dateTimeISO={v.dateLive} showTime={(minutes??100)>-60}/>
    let startDescription = <TimeLeft video={v} currentDate={currentDate}/>

    let notLiveWarning =  (v.inTheFuture && !v.isLiveSession);

    let notes = <></>

    if (!props2.hideWarnings && !v.inTheFuture)
    {
    if (!v.accessible) {
        if (loggedIn) {
            
            //notes = <>This video is only available to {v.subscriberLevel} subscribers. Please <a href='mailto:info@rawumberstudios.com'> contact us</a> to upgrade</>
            notes = <>This video is only available to Gold subscribers. Please <a href='mailto:info@rawumberstudios.com'> contact us</a> to upgrade</>

        }
        else {
            let h = '/log-in?redirect_to=' + encodeURIComponent(url);
            notes = <>To access this video, please <Link href={h}> log on</Link> or <Link href='/raw-umber-subscription/'> purchase a subscription</Link></>
        }
    }}

    if (notLiveWarning )
    {
        notes=<>Note that this video isn&rsquo;t a live session, so there will be no live chat.</>
    }

    let i = <></>
    
    if (ClassNames.length==0)
    {
        i = <div>{image}</div>
    }
    else
    {
        i = <div className={containerClass}>{image}</div>
    }

    let style : CSSProperties = props2.featured?{borderColor:'red', borderWidth:'3px'}:{};

    return <>

    <div className={styles.result} key={'v-' + v.id} style={style}>
        {props2.featured && <CornerBanner text="Featured!" color='white' backgroundColor='#e00'/>}
        <div className={styles.outerContainer}>
            {i}
        </div>
        <div className={styles.description}>
            <div className={styles.name}>
                {title}
            </div>
            <div className={styles.author}>
                {tutorName}
            </div>
            <div className={styles.date}>
                {videoDate}
            </div>
            <div className={styles.description}>
                {v.description}
            </div>
            <div className={styles.notes}>
                <div key='text' className={styles.notesText}>
                    {startDescription}
                </div>
                <div key='notes' className={styles.notesText}>
                    {notes}
                </div>
            </div>
        </div>
    </div>
    </>
}

export function TimeLeft(props : {video:Video, currentDate:DateTime, link?:JSX.Element, showEvenIfInPast?:boolean})
{
    let minutes = (DateTime.fromISO(props.video.dateLive).diff(props.currentDate).as("milliseconds")/60/1000);

    let videoDate = <DateAndTime dateTimeISO={props.video.dateLive} showTime={(minutes??100)>-60}/>
    let text = <></>;
    let colour = "#000";
    let isLive = props.video.isLiveSession;

    let sessionText = isLive?"This session will start":"This video will be available";

    if (minutes)
    {
    if (minutes < 15) {
        colour = "#c7782e";
    }

    if (minutes > -60) {
        if (minutes >= 0) {
            //text = "This live session will be broadcast on " + dateString + ". ";
            let m = Math.floor(minutes + 0.5);
            let hours = Math.floor(m / 60);
            let days = Math.floor(hours / 24);
            hours = hours % 24;
            let mins = m % 60;

            if (hours == 0 && days == 0) {
                if (minutes < 2) {
                    text = <b style={{ color: '#087817' }}>{sessionText} in a minute or two. {props.link}</b>
                }
                else {

                    if (minutes > 15) {
                        text = <b style={{ color: '#babd5e' }}>{sessionText} in {mins} minutes&rsquo; time.</b>
                    }
                    else {
                        text = <b style={{ color: '#babd5e' }}>{sessionText} in {mins} minutes&rsquo; time. {props.link}</b>

                    }
                }
            }
            else {
                let t = sessionText + " in ";
                if (days != 0) {
                    t += days + " day" + (days == 1 ? "'s" : "s'") + " time.";
                }
                else {
                    t += hours + " hour" + (hours == 1 ? "" : "s") + ", " + mins + " minutes' time.";
                }

                text = <b>{t}</b>
            }
        }
        else if (minutes > -60) {
            text = <b style={{ color: '#207537' }}>This session went live {(Math.round(-minutes) + 1)} minutes ago. {props.link}</b>
        }
    }
    else {
        if (props.showEvenIfInPast)
        {
            text = <span style={{ color: '#a11624' }}>This session was broadcast on {videoDate}. {props.link}</span>
        }
    }
    }

    return text;

}

// eslint-disable-next-line react/display-name
export const JWPlayer= forwardRef<JWPlayerHandle, JWPlayerProps> ((props,ref) =>

{

    const [firstRender, setFirstRender] = useState(true);

    useEffect(() => {
        setFirstRender(false);
    }, []);

    let playerId = 'jw-' + (props.uniqueKey??props.video.id);

    useEffect(() => {
      
        let v = props.video;

        let url = 'https://vod.rawumberstudios.com/' + v.id;
        let image = url+(props.large?"/thumbnail_1920.jpg":"/thumbnail_360.jpg");
        let player : jwplayer.JWPlayer | undefined;

       if (typeof jwplayer!=='undefined')
        {

        let e = jwplayer(playerId);

        let tracks : any [] = [];

        if (v.hasSubtitles) {
            tracks = [{
                kind: 'captions',
                file: url + '/subtitles.vtt',
                label: 'English'
            }];
        }

        if (typeof (e.setup) === 'function') {
            player = jwplayer(playerId).setup(
                {
                    autostart: false,
                    file: url + '/master.m3u8',
                    image: image,
                    tracks: tracks,
                    renderCaptionsNatively: false
                });
            setupJwEvents(player, v.id, props.videoFinished);
        }
    }

    return() => {
        destroyJwEvents(v.id)
        if (player)
        {
            try
            {
                player.remove();
            }
            catch
            {
                //I think maybe this errors because the player hasn't been fully set up yet??
                consoleLog("Couldn't remove player");
                //do nothing
            }

        }
    };

    }, [props.video, props.large, firstRender]);

    useImperativeHandle(ref, () => ({
        
        rewatch()
        {
            let j = videoPlayers.get(props.video.id);

            if (j)
            {
                j.player.seek(0);
                j.player.play();
            }
        }
    }));

    if (typeof window == 'undefined' || firstRender)
    {
        consoleLog("Rendering placeholder for " + playerId);
        console.log(props);
        if (props.placeHolder)
        {
            return <div id={`${playerId}-placeholder`}>{props.placeHolder}</div>
        }        
        return <AspectBox absolute={true} width={16} height={9} key={`${playerId}-placeholder`}>
            <div id={`${playerId}-placeholder`}>
                <img style={{position:'absolute', left:0, top:0, width:'100%', height:'100%'}} src={'https://rawumberstudios.com/rus-videos/images/previews/' + props.video.thumbnail}/>
                </div>
                </AspectBox>
    }
    else
    {
        //consoleLog("Returning player");
        return <AspectBox absolute={true} width={16} height={9}><SafeJWPlayer id={playerId}/></AspectBox>
    }

}
);

function playerTimer(playerId : number): void {
    let t = videoPlayers.get(playerId);
    if (t) {
        t.count += _interval;
        let seconds = t.count / 1000;

        let percentage = 100 * seconds / t.totalDuration;
        let id = t.videoId;

        if (seconds > 30 && !t.seconds30) {
            //watched 30 seconds
            t.seconds30 = true;
            logEvent("video_watched_seconds", { video_id: id, seconds: 30 })
        }

        if (seconds > 300 && !t.seconds300) {
            //watched 30 seconds
            t.seconds300 = true;
            logEvent("video_watched_seconds", { video_id: id, seconds: 300 })
           // console.log("Been running for " + percentage + "% - " + seconds + "/" + t.totalDuration);
        }

        if (percentage > 1 && !t.percentage1) {
            //watched 25 percent
            t.percentage1 = true;
            logEvent("video_watched_percentage", { video_id: id, percentage: 1 })
           // console.log("Been running for " + percentage + "% - " + seconds + "/" + t.totalDuration);
        }

        if (percentage > 25 && !t.percentage25) {
            //watched 25 percent
            t.percentage25 = true;
            logEvent("video_watched_percentage", { video_id: id, percentage: 25 })
        }

        if (percentage > 50 && !t.percentage50) {
            t.percentage50 = true;
            logEvent("video_watched_percentage", { video_id: id, percentage: 50 })
        }
        if (percentage > 75 && !t.percentage75) {
            t.percentage75 = true;
            logEvent("video_watched_percentage", { video_id: id, percentage: 75 })
        }
        if (percentage > 95 && !t.percentage95) {
            t.percentage95 = true;
            logEvent("video_watched_percentage", { video_id: id, percentage: 95 })
        }

    }
}

function destroyJwEvents(id: number)
{
    let j = videoPlayers.get(id);

    if (j)
    {
        window.clearInterval(j.timerId);
        videoPlayers.delete(id);
       // j.player.remove();
    }

}
function setupJwEvents(player: jwplayer.JWPlayer, id: number, videoFinished?: ()=>void) {


    player.on('play', (e: any) => {

        videoPlayers.forEach((x, k) => {
            if (k != id) {
                x.player.pause();
            }
        });

        let j = videoPlayers.get(id);

        if (j) {
            let duration: number = player.getDuration();
            j.totalDuration=duration;
            videoPlayers.set(id, j);
            if (j.running) {
            }
            else {
                let i = window.setInterval(playerTimer, _interval, id);
                j.timerId = i;
                j.running = true;
                videoPlayers.set(id, j);
            }
        }});

        let j = videoPlayers.get(id);
        if (!j)
        {
            let info: VideoPlayInformation =
            {
                timerId: 0,
                seconds: 0,
                previousPosition: 0,
                seconds30: false,
                seconds300: false,
                percentage1: false,
                percentage25: false,
                percentage50: false,
                percentage75: false,
                percentage95: false,
                videoId: id,
                count: 0,
                totalDuration: 0,
                running: false,
                player: player
            }

            videoPlayers.set(id, info);
        }

    player.on('pause', (e: any) => {

        let p = videoPlayers.get(id);
        if (p) { 

            window.clearInterval(p.timerId);
            p.running = false;

            
            }
    });

    player.on('complete', () => {
        let p = videoPlayers.get(id);

        if (p) {
            window.clearInterval(p.timerId);        
        }

        if (videoFinished)
        {
            videoFinished();
        }

    });

    

}


interface RelatedVideoProps {
    videoId: number,
    videos: Video []
}

interface RelatedVideoElementProps {
    video: Video
    fromId: number
}

class RelatedVideoClickInfo {
    fromId: number | undefined;
    url: string | undefined;
    toId: number | undefined;
    toSlug: string | undefined;
    page: string | undefined;
}


export default function RelatedVideos(props: RelatedVideoProps) {

    let a: JSX.Element[] = [];

    for (var video of props.videos) {
        if (!(video.inTheFuture && video.excludeFromUpcoming))
            {
            a.push(<RelatedVideoElement key={video.id} video={video} fromId={props.videoId}/>);
            }
    }

    return <div className={styles.relatedVideosBlock}><div className={styles.relatedVideosHeader}>Enjoyed this video? You might like these too:</div><div className={styles.relatedVideos}>{a}</div></div>;

    }

    function relatedClick(v: Video, fromId: number, e: React.MouseEvent<HTMLElement>): void {

        let ev: RelatedVideoClickInfo = new RelatedVideoClickInfo();
        ev.toId = v.id;
        ev.toSlug = v.slug;
        ev.fromId = fromId;
        ev.page = location.href;

        logEvent('related_video', ev)

    }

    function RelatedVideoElement(props2: RelatedVideoElementProps) {

        let v: Video = props2.video;

        let image = <></>;
        let url = '/videos/' + v.slug

        image = <Link href={url} onClick={(e: React.MouseEvent<HTMLElement>) => relatedClick(v, props2.fromId, e)}><img src={'https://rawumberstudios.com/rus-videos/images/thumbnails/' + v.thumbnail}  /></Link>;

        let title = <Link href={url} onClick={(e: React.MouseEvent<HTMLElement>) => relatedClick(v, props2.fromId, e)}>{v.title}</Link>;

        let notes = <></>

        return <div className={styles.relatedVideo}>
                <div className={styles.relatedVideoImage}>
                    {image}
                </div>
            <div className={styles.relatedVideoDescription}>
                <div className={styles.relatedVideoName}>
                    {title}
                </div>
                <div className={styles.relatedVideoText}>
                    {TrimDescription(v.description)}
                </div>
            </div>
        </div>

    }

    export function AncillaryLinks(props: {links: VideoAncillaryLink[], showAll?: boolean})
    {
      if (props.links.length==0)
      {
        return <></>
      }
    
      let i = 0;

      let html = props.links.map(x=>
      {
        if (props.showAll || !x.notLive)
        {
          return  <li key={i++}><Link href={x.url}>{x.description}</Link></li>
        }
      });
      
      return <div className={styles.additionalLinks}>
        <div className={styles.linksHeader}>Additional materials / links</div>
        <ul>{html}</ul>
      </div>
    }

    export type VideoPlayerHandle = {
        play: () => void;
        lowerQuality: () => void;
        unMute: () => void;
        refresh: () => void;
        getLiveViewerCount:  ()=> Promise<number | undefined>
      };

        type JWPlayerHandle = {
        rewatch: () => void;
       
      };
// eslint-disable-next-line react/display-name
    export const LiveVideo= forwardRef<VideoPlayerHandle, {video:Video, dateProcessed: string}>((props,ref) =>
    
    {

        let m = (DateTime.fromISO(props.video.dateLive).diff(DateTime.fromISO(props.dateProcessed).toUTC()).as("milliseconds")/60/1000);

        const [minutes, setMinutes] = useState(m);
        const [refreshValue, setRefreshValue] = useState(1);
        const {timeOffset} = useRawUmberContext();

        useImperativeHandle(ref, () => ({
        
            refresh()
            {

                let realDate = DateTime.now().toUTC().plus(timeOffset??0);
                let m = (DateTime.fromISO(props.video.dateLive).diff(realDate).as("milliseconds")/60/1000);
                setMinutes(m);
                setRefreshValue(refreshValue+1);
            },
            play() {
              ref2.current?.play();
            },
            lowerQuality()
            {
                ref2.current?.lowerQuality();
            },
            unMute() {
                ref2.current?.unMute();
            },
            async getLiveViewerCount() : Promise<number | undefined>
            {                
                return await ref2.current?.getLiveViewerCount();
            }
          }));

        const ref2 = useRef<VideoPlayerHandle>(null);


        if (minutes<=15)
        {
            return <JWLivePlayer video={props.video} dateProcessed={props.dateProcessed} ref={ref2}/>
        }
        return <div className={styles.bigContainer}>
        <img className={styles.bigLockedImage} src={"https://rawumberstudios.com/rus-videos/images/previews/" + props.video.thumbnail}/>
        <div className={styles.centredOverlay}>
            <div className={styles.upcomingText}>This video will live stream on <DateAndTime dateTimeISO={props.video.dateLive} showTime={true}/></div>
        </div>
        </div>
    }

    
    );


// eslint-disable-next-line react/display-name
      export const JWLivePlayer = forwardRef<VideoPlayerHandle, JWPlayerProps>((props, ref) => {
        useImperativeHandle(ref, () => ({
        
          play() {
            jwplayer('jw-live-player').play();
          },
          lowerQuality()
          {
            jwplayer('jw-live-player').setCurrentQuality(3);
          },
          unMute() {
            jwplayer('jw-live-player').setVolume(100);
          },      
          refresh() {},

          async  getLiveViewerCount() 
          {
              if (!isVideoWithinTime()) {
                  return 0;
              }
          
              try

              {
                let options = { method: 'GET'};

                let at =  await fetch(process.env.NEXT_PUBLIC_LOGGER_ROUTE + "/liveviewers?slug=" + props.video.privateRedirect, options);
    
                let k = await at.json();

                return Number(k.viewers);
              }
              catch 
              {
                return undefined;
              }
          }
        }));
    
        const [livePlayer, setLivePlayer] = useState<jwplayer.JWPlayer | null>(null);
        const [playingLoop, setPlayingLoop] = useState(false);
        const [currentDate, setCurrentDate] = useState(DateTime.fromISO(props.dateProcessed));
        const {timeOffset} = useRawUmberContext();
        const [liveVideoPlaying, setLiveVideoPlaying] = useState(false);

        let url = 'https://live.rawumberstudios.com/livea/main.m3u8';
        let image = "https://rawumberstudios.com/rus-videos/images/previews/" + props.video.thumbnail;

        //const [playList, setPlayList] = useState<{file:string, image:string } []>({file: url, image:image});

        let playList = [{file:url, image:image}];

        let m = (DateTime.fromISO(props.video.dateLive).diff(currentDate).as("milliseconds")/60/1000);
        
        function reconnect() {

            consoleLog("Reconnecting");
            let e = jwplayer('jw-live-player');
            if (e) {
           
                    setPlayingLoop(false);
                    if (playList)
                    {
                 
                        e.load(playList);
                    }
                    e.play();
                    
        
                //}
            }
        }

        function onJWAutostartNotAllowed()
        {
            
        } 

        function onJWError(e: jwplayer.ErrorParam)
        {

            setTimeout(reconnect, 10000);

            setPlayingLoop(true);

            var p = [{
                "file": "https://rawumberstudios.com/rus-live/loading.mp4"
            }];

            let x = jwplayer('jw-live-player');

            if (x)
            {
                try {
                    x.load(p);
                    x.play();
                }
                catch (error) {
                
                    console.error(error);
                }    
            }

    
        }

        function logLivePlay()
            {
                //console.log("Logging live watch for " + rus_live_slug);
                logEvent("video_watched_live", {video_slug: props.video.privateRedirect});
            }
        useEffect(() => {
            let v = props.video;
            let url = 'https://live.rawumberstudios.com/livea/main.m3u8';
            let image = "https://rawumberstudios.com/rus-videos/images/previews/" + v.thumbnail;
    


            let timerId :number ;
            let aliveTimerId: number;

           if (typeof jwplayer!=='undefined')
            {
    
    
            let e = jwplayer('jw-live-player');
    
            if (typeof (e.setup) === 'function') {
                
                let player = e.setup(
                    {
                        playlist: playList,
                        autostart: true,
                        mute: true
                    });
                    player.on("error", onJWError);
                    setupMetaHandler(player, props.video.slug);
                    //player.on("autostartNotAllowed", onJWAutostartNotAllowed);


            }

            timerId = window.setTimeout(() => {
                logLivePlay();
            }, 1000 * 60 * 10);


            let realDate = DateTime.now().toUTC().plus(timeOffset??0)
            setCurrentDate(realDate);
            
            addEventListener('visibilitychange', async (event) => {await visibilityChanged()});   
            logLiveStart();

            aliveTimerId = window.setInterval(logLiveKeepAlive, 30000);
        
        }

        return (() =>
        {
            jwplayer('jw-live-player').remove();
            if (timerId)
            {
                window.clearTimeout(timerId);
            }
            if (aliveTimerId)
            {
                window.clearInterval(aliveTimerId);
            }
        })
    
        }, []);

        async function visibilityChanged() {
            if (document.visibilityState=='visible')
            {
                await logLiveStart();
            }
            else
            {
                await logLiveEnd();
            }

        }
    
        function isVideoWithinTime()
        {
            let m = (DateTime.fromISO(props.video.dateLive).diff(currentDate).as("milliseconds")/60/1000);
            if (m>-90 && m<90)
            {
                return true;
            }
            return false;
        }

        async function logLiveEvent(event:string)
        {
            if (!isVideoWithinTime()) {

                return;
            }

            let [c,t] = await registerBrowser();

            let p = {
                 slug: props.video.privateRedirect,
                 token: t,
                 browserId:c
                };
            try
            {
                navigator.sendBeacon(process.env.NEXT_PUBLIC_LOGGER_ROUTE + "/" + event, JSON.stringify(p));
            }
            catch (e)
            {
                //fail silently
            }


        }

        async function logLiveStart() {

            if (liveVideoPlaying) {
                return;
            }
                
            setLiveVideoPlaying(true);
        
           // await logLiveEvent("startwatchingvideo");
        }

        async function logLiveKeepAlive() {
            await logLiveEvent("stillwatchingvideo");
        }

        
        async function logLiveEnd() {

            if (!liveVideoPlaying) {
                return;
            }
        
            setLiveVideoPlaying(false);

           // await logLiveEvent("stopwatchingvideo");
        }
    

        if (props.placeHolder)
        {
            return <div id='jw-live-player'>{props.placeHolder}</div>
        }
        else
        {
                 return <div className={styles.videoWrapper} style={{position:'relative'}}>
                    <div id='jw-live-player'></div>
                        <a id="subscribe-link" className="video-overlay-link"
     href="https://rawumberstudios.com/subscribe"
     target="_blank">
            <button className="video-subscribe-btn">
  <span className="video-subscribe-text">Subscribe Now 🡒</span>
  <span className="video-subscribe-glow"></span>
</button>        
  </a>

                <div id="subscribe-overlay">
                <a className="video-overlay-page"
     href="https://rawumberstudios.com/subscribe"
     target="_blank">
            <button className="video-large-subscribe-btn">
  <span className="video-subscribe-text">Subscribe Now 🡒</span>
  <span className="video-subscribe-glow"></span>
</button>        
  </a>
  </div>
                 </div>
     

        }
        
    });
    
    function setupMetaHandler(player: jwplayer.JWPlayer, slug: string)
    {

        function showScreen(id: string)
        {
            const node : HTMLAnchorElement | null = document.getElementById(id) as HTMLAnchorElement;
            if (node)
            {
            
                node.style.display="block";

                const timer=setTimeout(()=>
                {
                    node.style.display="none";

                },10000);
                return ()=> clearTimeout(timer);
            }

        }
                    player.on('meta', function(event) {
                        const d =event.metadata.messageData as Uint8Array;

                        if (d)
                        {
                            const text = new TextDecoder("utf-8").decode(d);
                            if (text.startsWith("RU#"))
                            {
                                const payload = JSON.parse (text.substring(3));

                                switch (payload.action)
                                {
                                    case "subscribeLink":
                                       showScreen("subscribe-link");

                                        break;
                                case "subscribePage":
                                    showScreen("subscribe-overlay");
                                    break;
                                }

                            }

                        }
                    });

                    //set up logging events

                    const subscribeNode : HTMLAnchorElement | null = document.getElementById("subscribe-link") as HTMLAnchorElement;
                    if (subscribeNode)
                        {
                            subscribeNode.onclick = () =>
                            {
                                logEvent("live_subscribe_link_clicked", {video_slug: slug});
                                trackFathomEvent("live-subscribe-link-clicked");
                            }
                        }
                    


    }
    
    
